document.addEventListener("DOMContentLoaded", () => {
    initWowText();
    window.addEventListener("scroll", throttle(wowText, 250));
    window.addEventListener("resize", throttle(handleResize, 250));
});

function initWowText() {
    wowText();
}

function isElementVisible(element) {
    const rect = element.getBoundingClientRect();
    const viewHeight = Math.max(
        document.documentElement.clientHeight,
        window.innerHeight,
    );
    return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
}

function wowText() {
    const wowTextElements = document.querySelectorAll("span.wow-text");
    wowTextElements.forEach((element) => {
        if (isElementVisible(element)) {
            convertToSVG(element);
        }
    });
}

function convertToSVG(element) {
    const innerValue = element.innerText;
    const width = element.offsetWidth;
    const height = element.offsetHeight;

    const svgElement = createSVGElement(width, height);
    const textElement = createTextElement(innerValue, height);

    svgElement.appendChild(textElement);
    adjustSVGPosition(svgElement, textElement, height);

    element.parentNode.replaceChild(svgElement, element);
    animateSVG(svgElement);
}

function createSVGElement(width, height) {
    const svgElement = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "svg",
    );
    svgElement.setAttribute("width", width);
    svgElement.setAttribute("height", height);
    svgElement.classList.add("wow-text");
    return svgElement;
}

function createTextElement(innerValue, height) {
    const textElement = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "text",
    );
    textElement.textContent = innerValue;
    textElement.setAttribute("x", 0);
    textElement.setAttribute("y", height);
    return textElement;
}

function adjustSVGPosition(svgElement, textElement, height) {
    const textHeight = textElement.getBBox().height;
    const diff = height - textHeight;
    svgElement.style.marginTop = `-${diff}px`;
}

function animateSVG(svgElement) {
    svgElement.classList.add("animate-outline");
    setTimeout(() => {
        svgElement.classList.add("animate-fill");
    }, 1000);
}

function handleResize() {
    const wowTextElements = document.querySelectorAll("svg.wow-text");
    wowTextElements.forEach((element) => {
        const innerValue = element.firstChild.textContent;
        const spanElement = document.createElement("span");
        spanElement.textContent = innerValue;
        spanElement.style.color = "var(--wp--preset--color--accent)";
        element.parentNode.replaceChild(spanElement, element);
    });
}

function throttle(func, limit) {
    let lastFunc;
    let lastRan;
    return function () {
        const context = this;
        const args = arguments;
        if (!lastRan) {
            func.apply(context, args);
            lastRan = Date.now();
        } else {
            clearTimeout(lastFunc);
            lastFunc = setTimeout(
                () => {
                    if (Date.now() - lastRan >= limit) {
                        func.apply(context, args);
                        lastRan = Date.now();
                    }
                },
                limit - (Date.now() - lastRan),
            );
        }
    };
}
